import { render, staticRenderFns } from "./SoftwareVersionForm.vue?vue&type=template&id=4df93ddb&"
import script from "./SoftwareVersionForm.vue?vue&type=script&lang=ts&"
export * from "./SoftwareVersionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports